import type {UserName} from '../../types';

import {Input} from '@ds/components';

type UserFormProps = {
  user: UserName;
  onChange: (field: keyof UserName, event: React.ChangeEvent<HTMLInputElement>) => void;
};

const UserForm: React.FC<UserFormProps> = ({user, onChange}) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <Input
        value={user.name}
        label="نام"
        required
        placeholder="نام"
        onChange={(event) => onChange('name', event)}
      />
      <Input
        value={user.lastname}
        label="نام خانوادگی"
        required
        placeholder="نام خانوادگی"
        onChange={(event) => onChange('lastname', event)}
      />
    </div>
  );
};

export default UserForm;
